import { isEnvDevelopment } from 'src/helpers';

export function getLocalFullUrl(imgUrl?: string) {
  return imgUrl ? `${imgUrl.includes('http') ? '' : process.env.NEXT_PUBLIC_BACKEND_BASE_URL}${imgUrl}` : ''
}
